import { CIcon } from '~/icons/types'

export const ciCall: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.14 16.07 16.72 15a2.12 2.12 0 0 0-2.22.79l-1 1.33A10.72 10.72 0 0 1 7 10.47l1.29-1A2.12 2.12 0 0 0 9 7.28L7.93 2.86a2.11 2.11 0 0 0-2.06-1.61H4.5A3.26 3.26 0 0 0 1.25 4.5v2.25a16 16 0 0 0 16 16h2.25a3.26 3.26 0 0 0 3.25-3.25v-1.37a2.11 2.11 0 0 0-1.61-2.06Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'call',
  type: 'solid'
}
